export interface GoogleMarker {
    position: google.maps.LatLng;
    label: Label;
    title: string;
    options?: Options;
    icon?: HTMLElement;
    info?: string;
    childs?: InfoContentData[];
    groups?: DeviceGroupData[];
    draggable?: boolean;
}

export interface ParkingGoogleMarker extends GoogleMarker {
    free?: number;
    occupied?: number;
}

class ParkingGoogleMarkerData {
  free: number;
  occupied: number;
}

interface Label {
    color: string,
    text: string,
    fontSize: string,
    fontWeight: string,
    labelOrigin: google.maps.Point,
    anchor: google.maps.Point,
    origin: google.maps.Point,
    scaledSize: google.maps.Size
}

interface Options {
    animation?: google.maps.Animation;
    icon?: google.maps.Icon;
    draggable?: boolean;
}

export class InfoContentData {
    Name: string
    Icon: string
    Elements: number;

    constructor(name: string, icon: string) {
        this.Name = name;
        this.Icon = icon;
        this.Elements = 1;
    }
}

export class DeviceGroupData{
    Id : string
    Name: string
    Color: string

    constructor(id: string, name: string, color: string) {
        this.Id = id;
        this.Name = name;
        this.Color = color;
    }
}
